.dropdownContainer {
  position: relative;
  width: fit-content;
  display: flex;
}

.dropdownMenuContainer {
  background-color: var(--secondary-enabled);
  border-radius: 6px;
  box-shadow: var(--box-shadow);
  margin: 5px 0;
}

.right {
  justify-content: flex-end;
}

.left {
  justify-content: flex-start;
}

.center {
  justify-content: center;
}

.dropdownList {
  padding: 4px;
  margin: 0;
}

.dropdownOption {
  color: var(--static-text-standard);
  cursor: pointer;
  list-style-type: none;
  border-radius: 6px;
  min-width: 180px;
  padding: 4px 12px;
}
.dropdownOption:hover {
  background-color: var(--selectable-hover);
}